import { render, staticRenderFns } from "./AboutUsPart4.vue?vue&type=template&id=67fb6c70&scoped=true&"
import script from "./AboutUsPart4.vue?vue&type=script&lang=js&"
export * from "./AboutUsPart4.vue?vue&type=script&lang=js&"
import style0 from "./AboutUsPart4.vue?vue&type=style&index=0&id=67fb6c70&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fb6c70",
  null
  
)

export default component.exports